"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment-timezone");
exports.ListDateTimezoneComponent = (props) => {
    return React.createElement("p", null, props.model && (moment(props.model.date).tz(props.model.timezone).format("LLL") + "  " + props.model.timezone));
};
//# sourceMappingURL=ListDateTimezoneComponent.js.map